import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Database, BarChart, Trash2, Trophy, AlertCircle, Target, User } from "lucide-react";
import { CARD, PRIMARY_BTN } from "./adminStyles";

export const AdminDataTab = ({ loading, onGenerateAccounts, onGeneratePipeline, onClear }) => (
  <Card className={`${CARD} p-6`} data-testid="admin-data-tab">
    <h2 className="text-xl font-bold text-white mb-6">Demo Data Generator</h2>
    <div className="space-y-4">
      <Button onClick={onGenerateAccounts} disabled={loading} className={`w-full ${PRIMARY_BTN} justify-start`} data-testid="gen-accounts-btn">
        <Database className="h-4 w-4 mr-2" /> Generate Sample Accounts (10-20)
      </Button>
      <Button onClick={onGeneratePipeline} disabled={loading} className={`w-full ${PRIMARY_BTN} justify-start`} data-testid="gen-pipeline-btn">
        <BarChart className="h-4 w-4 mr-2" /> Generate Sample Pipeline (15-25)
      </Button>
      <Button onClick={onClear} disabled={loading} variant="destructive" className="w-full justify-start" data-testid="clear-data-btn">
        <Trash2 className="h-4 w-4 mr-2" /> Clear All Data
      </Button>
    </div>
  </Card>
);

const SCENARIOS = [
  { id: "crushing-it", label: "Crushing It", hint: "95% to goal", icon: Trophy, cls: "bg-green-500/10 hover:bg-green-500/20 border-green-500/30", iconCls: "text-green-400", testId: "scenario-crushing" },
  { id: "behind-pace", label: "Behind Pace", hint: "40% to goal", icon: AlertCircle, cls: "bg-red-500/10 hover:bg-red-500/20 border-red-500/30", iconCls: "text-red-400", testId: "scenario-behind" },
  { id: "mid-quarter", label: "Mid-Quarter Push", hint: "65% to goal", icon: Target, cls: "bg-yellow-500/10 hover:bg-yellow-500/20 border-yellow-500/30", iconCls: "text-yellow-400", testId: "scenario-mid-quarter" },
  { id: "new-user", label: "New User", hint: "Fresh start", icon: User, cls: "bg-gray-500/10 hover:bg-gray-500/20 border-gray-500/30", iconCls: "text-gray-400", testId: "scenario-new-user" },
];

export const AdminScenariosTab = ({ loading, onLoad }) => (
  <Card className={`${CARD} p-6`} data-testid="admin-scenarios-tab">
    <h2 className="text-xl font-bold text-white mb-6">Scenario Presets</h2>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      {SCENARIOS.map(({ id, label, hint, icon: Icon, cls, iconCls, testId }) => (
        <Button key={id} onClick={() => onLoad(id)} disabled={loading} className={`h-24 flex-col border text-white ${cls}`} data-testid={testId}>
          <Icon className={`h-6 w-6 mb-2 ${iconCls}`} />
          <span className="font-semibold">{label}</span>
          <span className="text-xs text-gray-400">{hint}</span>
        </Button>
      ))}
    </div>
  </Card>
);
